import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Stat} from '../../../types/stats';

export type ResultSliceInterface = {
  value: Stat | null;
};

const initialState: ResultSliceInterface = {
  value: null,
};

const ResultSlice = createSlice({
  name: 'resultSlice',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Stat>) => {
      state.value = action.payload;
    },

    reset: () => initialState,
  },
});

export const {set, reset} = ResultSlice.actions;
export default ResultSlice.reducer;
